export default __webpack_public_path__ + "static/media/bowl.3ade1ea8.png";